export function headerSpNav() {
  const $headerNavContainer = $('#header-nav-container');
  const $headerSpOverlay = $('#header-sp-overlay');
  const $headerSpTrigger = $('#header-sp-trigger');
  $(document).on('click', '#header-sp-trigger', function() {
    if ($(this).hasClass('is-sp-nav-active')) {
      $(this).removeClass('is-sp-nav-active');
      $headerNavContainer.removeClass('is-show-sp');
      $headerSpOverlay.removeClass('is-sp-nav-active');
      $(document.body).removeClass('is-sp-nav-active');
    } else {
      $(this).addClass('is-sp-nav-active');
      $headerNavContainer.addClass('is-show-sp');
      $headerSpOverlay.addClass('is-sp-nav-active');
      $(document.body).addClass('is-sp-nav-active');
    }
    return false;
  });
  $(document).on('click', '#header-sp-overlay', function() {
    $(this).removeClass('is-sp-nav-active');
    $headerNavContainer.removeClass('is-show-sp');
    $headerSpTrigger.removeClass('is-sp-nav-active');
    $(document.body).removeClass('is-sp-nav-active');
    return false;
  });
  $(document).on('click', '.is-nav-inbound', function() {
    $headerSpOverlay.removeClass('is-sp-nav-active');
    $headerNavContainer.removeClass('is-show-sp');
    $headerSpTrigger.removeClass('is-sp-nav-active');
    $(document.body).removeClass('is-sp-nav-active');
  });
}